import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig";
import * as Yup from "yup";
let moduleConfig = {};
moduleConfig = {
  ...moduleDefaultConfig,
};

moduleConfig.hasStatusSearch = false;

moduleConfig.title = "School/Nursery Requests";
moduleConfig.singleItemTitle = "School/Nursery Request";
moduleConfig.url = "school-nursery-requests";

moduleConfig.buttons = {
  create: false,
  view: true,
  update: false,
  delete: true,
};

moduleConfig.bulkActions = [
  {
    displayName: "Delete Selected",
    value: "Delete",
  },
];

moduleConfig.fields = [
  {
    displayName: "ID",
    fieldName: "_id",
    type: "text",
    control: "hidden",
  },
  {
    displayName: "School Nursery Name",
    fieldName: "schoolNurseryName",
    type: "text",
    control: "input",
    showOnListing: true,
    sortable: true,
  },
  {
    displayName: "Contact Person Name",
    fieldName: "contactPersonName",
    type: "text",
    control: "input",
    showOnListing: true,
    sortable: true,
  },
  {
    displayName: "Contact Person Role",
    fieldName: "contactPersonRole",
    type: "text",
    control: "input",
    showOnListing: true,
    sortable: true,
  },
  {
    displayName: "Email",
    fieldName: "email",
    type: "email",
    control: "input",
    showOnListing: true,
    sortable: true,
  },

  {
    displayName: "Mobile",
    fieldName: "mobile",
    type: "number",
    control: "input",
    showOnListing: true,
    sortable: true,
    displayStyle: "phone",
  },
  {
    displayName: "Number Of Children",
    fieldName: "numberOfChildren",
    type: "text",
    control: "input",
    showOnListing: true,
    sortable: true,
  },
  {
    displayName: "Address",
    fieldName: "address",
    type: "text",
    control: "input",
    showOnListing: false,
    sortable: false,
  },
  {
    displayName: "City",
    fieldName: "city",
    type: "text",
    control: "input",
    showOnListing: false,
    sortable: false,
  },
  {
    displayName: "Message",
    fieldName: "message",
    type: "text",
    control: "input",
    showOnListing: false,
    sortable: false,
  },
  {
    displayName: "Submission Date",
    fieldName: "createdAt",
    type: "date",
    showOnListing: true,
    sortable: true,
    displayStyle: "text",
  },
  
];
moduleConfig.initialValues = {};
moduleConfig.validationSchema = Yup.object({});

export default moduleConfig;
